import { FILE_SUCCESS, FILE_DELETE } from 'app/actions/assistance/files';

const defaultState = {
};

const files = (state = defaultState, action) => {
  switch (action.type) {

    case FILE_SUCCESS: {
      return { ...state, ...action.payload };
    }

    case FILE_DELETE: {
      const newState = { ...state };
      delete newState[action.payload];
      return newState;
    }

    default:
  }
  return state;
};

export default files;
